import Vue from 'vue'

export function setZoneMapGenerationStatus (state, value) {
  state.ui.gettingZoneMap = value
}

export function updateZoneMapDetails (state, {fieldId, zoneMapDetails}) {
  Vue.set(state.data.field[fieldId], 'latestZoneMap', zoneMapDetails)
}
